const searchStrip = {
  hotels: "酒店", // translated
  city: "城市", // translated
  checkIn: "报到", // translated
  checkOut: "查看", // translated
  date: "日期", // translated
  persons: "人员", // translated
  adults: "成年人", // translated
  rooms: "客房", // translated
  editSearch: "编辑搜索", // translated
  newSearch: "新搜索", // translated
  listView: "列表显示", // translated
  mapView: "地图视图", // translated
};


export default searchStrip;
